export default "__VITE_ASSET__Ce3t2ZO0__"